import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const PoliticaPrivacidade = () => {
  useEffect(() => {
    document.title = "Política de Privacidade - 30 Receitas Express";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <Header hideCheckoutButton />
      <main className="py-12 md:py-16">
        <div className="container max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-bold mb-6">Política de Privacidade</h1>
          <p className="text-sm text-muted-foreground mb-8">Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

          <div className="prose prose-slate dark:prose-invert max-w-none space-y-6">
            <section>
              <h2 className="text-2xl font-semibold mb-4">1. Introdução</h2>
              <p className="text-muted-foreground leading-relaxed">
                A 30 Receitas Express ("nós", "nosso" ou "empresa") está comprometida em proteger a privacidade dos usuários ("você" ou "usuário") que adquirem nosso e-book de receitas. Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações pessoais.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">2. Informações que Coletamos</h2>
              <p className="text-muted-foreground leading-relaxed mb-3">
                Durante o processo de compra e uso de nossos serviços, podemos coletar as seguintes informações:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li><strong>Informações de identificação:</strong> nome completo, endereço de e-mail, número de telefone/WhatsApp</li>
                <li><strong>Informações de pagamento:</strong> dados necessários para processar a transação (processados por gateway de pagamento seguro)</li>
                <li><strong>Informações de acesso:</strong> endereço IP, tipo de navegador, páginas visitadas, horários de acesso</li>
                <li><strong>Informações de uso:</strong> interações com o e-book e nosso site</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">3. Como Usamos suas Informações</h2>
              <p className="text-muted-foreground leading-relaxed mb-3">
                Utilizamos suas informações pessoais para:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>Processar e entregar sua compra do e-book</li>
                <li>Enviar o link de download e o arquivo por e-mail e WhatsApp</li>
                <li>Fornecer suporte ao cliente e responder suas solicitações</li>
                <li>Enviar atualizações sobre o produto (com sua permissão)</li>
                <li>Melhorar nossos produtos e serviços</li>
                <li>Prevenir fraudes e garantir a segurança</li>
                <li>Cumprir obrigações legais e regulatórias</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">4. Compartilhamento de Informações</h2>
              <p className="text-muted-foreground leading-relaxed mb-3">
                Não vendemos, alugamos ou compartilhamos suas informações pessoais com terceiros, exceto nas seguintes situações:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li><strong>Prestadores de serviços:</strong> empresas que nos auxiliam no processamento de pagamentos, envio de e-mails e análise de dados</li>
                <li><strong>Cumprimento legal:</strong> quando exigido por lei ou para proteger nossos direitos legais</li>
                <li><strong>Transferência de negócios:</strong> em caso de fusão, aquisição ou venda de ativos</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">5. Armazenamento e Segurança</h2>
              <p className="text-muted-foreground leading-relaxed">
                Implementamos medidas de segurança técnicas e organizacionais para proteger suas informações pessoais contra acesso não autorizado, alteração, divulgação ou destruição. Seus dados são armazenados em servidores seguros com criptografia e acesso restrito.
              </p>
              <p className="text-muted-foreground leading-relaxed mt-3">
                Mantemos suas informações pelo tempo necessário para cumprir as finalidades descritas nesta política ou conforme exigido por lei.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">6. Seus Direitos (LGPD)</h2>
              <p className="text-muted-foreground leading-relaxed mb-3">
                De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem os seguintes direitos:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                <li>Confirmar a existência de tratamento de seus dados pessoais</li>
                <li>Acessar seus dados pessoais</li>
                <li>Corrigir dados incompletos, inexatos ou desatualizados</li>
                <li>Solicitar a anonimização, bloqueio ou eliminação de dados desnecessários</li>
                <li>Solicitar a portabilidade de seus dados</li>
                <li>Revogar o consentimento para o tratamento de dados</li>
                <li>Solicitar informações sobre o compartilhamento de dados</li>
              </ul>
              <p className="text-muted-foreground leading-relaxed mt-3">
                Para exercer seus direitos, entre em contato conosco através do e-mail: <a href="mailto:privacidade@receitasem30minutos.com.br" className="text-primary hover:underline">privacidade@receitasem30minutos.com.br</a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">7. Cookies e Tecnologias de Rastreamento</h2>
              <p className="text-muted-foreground leading-relaxed">
                Utilizamos cookies e tecnologias similares para melhorar a experiência do usuário, analisar o tráfego do site e personalizar conteúdo. Você pode configurar seu navegador para recusar cookies, mas isso pode afetar a funcionalidade do site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">8. Links para Sites de Terceiros</h2>
              <p className="text-muted-foreground leading-relaxed">
                Nosso site pode conter links para sites de terceiros. Não nos responsabilizamos pelas práticas de privacidade desses sites e recomendamos que você leia suas políticas de privacidade.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">9. Menores de Idade</h2>
              <p className="text-muted-foreground leading-relaxed">
                Nosso serviço não é direcionado a menores de 18 anos. Não coletamos intencionalmente informações pessoais de menores. Se você acredita que coletamos dados de um menor, entre em contato conosco imediatamente.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">10. Alterações nesta Política</h2>
              <p className="text-muted-foreground leading-relaxed">
                Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre mudanças significativas através do e-mail cadastrado ou por meio de aviso em nosso site. A data da última atualização será sempre indicada no topo desta página.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">11. Contato</h2>
              <p className="text-muted-foreground leading-relaxed">
                Se você tiver dúvidas ou preocupações sobre esta Política de Privacidade ou sobre o tratamento de seus dados pessoais, entre em contato conosco:
              </p>
              <ul className="list-none space-y-2 text-muted-foreground mt-3">
                <li><strong>E-mail:</strong> <a href="mailto:privacidade@receitasem30minutos.com.br" className="text-primary hover:underline">privacidade@receitasem30minutos.com.br</a></li>
                <li><strong>Responsável:</strong> 30 Receitas Express</li>
              </ul>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PoliticaPrivacidade;
